import { render, staticRenderFns } from "./NglView.vue?vue&type=template&id=18132472&scoped=true&"
import script from "./NglView.vue?vue&type=script&lang=js&"
export * from "./NglView.vue?vue&type=script&lang=js&"
import style0 from "./NglView.vue?vue&type=style&index=0&id=18132472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18132472",
  null
  
)

export default component.exports